import { Namespace } from 'cls-hooked';
import { NextPageContext } from 'next';

type IServerSession = Namespace<{ context: NextPageContext }>;

let session: IServerSession;
if (typeof window === 'undefined') {
  const createNamespace = require('cls-hooked').createNamespace;
  session = createNamespace('next.js session');
}

export const setServerContext = (nextPageContext: NextPageContext) => {
  if (session && session.active) {
    session.set('context', nextPageContext);
  }
};

export const getServerContext = (): NextPageContext => {
  if (session && session.active) {
    return session.get('context');
  } else {
    return undefined;
  }
};

export const getServerSession = (): IServerSession => {
  return session;
};
